'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchShippingTemplatesIfNeeded = exports.failureShippingTemplates = exports.receiveShippingTemplates = exports.requestShippingTemplates = exports.invalidateShippingTemplates = exports.filterShippingTemplates = exports.INVALIDATE_SHIPPING_TEMPLATES = exports.FILTER_SHIPPING_TEMPLATES = exports.FAILURE_SHIPPING_TEMPLATES = exports.RECEIVE_SHIPPING_TEMPLATES = exports.REQUEST_SHIPPING_TEMPLATES = undefined;

var _api = require('../api');

var REQUEST_SHIPPING_TEMPLATES = exports.REQUEST_SHIPPING_TEMPLATES = 'REQUEST_SHIPPING_TEMPLATES'; /**
                                                                                                     * 自提点相关Actions
                                                                                                     */
var RECEIVE_SHIPPING_TEMPLATES = exports.RECEIVE_SHIPPING_TEMPLATES = 'RECEIVE_SHIPPING_TEMPLATES';
var FAILURE_SHIPPING_TEMPLATES = exports.FAILURE_SHIPPING_TEMPLATES = 'FAILURE_SHIPPING_TEMPLATES';
var FILTER_SHIPPING_TEMPLATES = exports.FILTER_SHIPPING_TEMPLATES = 'FILTER_SHIPPING_TEMPLATES';
var INVALIDATE_SHIPPING_TEMPLATES = exports.INVALIDATE_SHIPPING_TEMPLATES = 'INVALIDATE_SHIPPING_TEMPLATES';

var filterShippingTemplates = exports.filterShippingTemplates = function filterShippingTemplates(filter) {
    return {
        type: FILTER_SHIPPING_TEMPLATES,
        filter: filter
    };
};

var invalidateShippingTemplates = exports.invalidateShippingTemplates = function invalidateShippingTemplates(filter) {
    return {
        type: INVALIDATE_SHIPPING_TEMPLATES,
        filter: filter
    };
};

var requestShippingTemplates = exports.requestShippingTemplates = function requestShippingTemplates(filter) {
    return {
        type: REQUEST_SHIPPING_TEMPLATES,
        filter: filter
    };
};

var receiveShippingTemplates = exports.receiveShippingTemplates = function receiveShippingTemplates(filter, json) {
    return {
        type: RECEIVE_SHIPPING_TEMPLATES,
        filter: filter,
        shippingTemplates: json,
        received_at: Date.now()
    };
};
var failureShippingTemplates = exports.failureShippingTemplates = function failureShippingTemplates(error) {
    return {
        type: FAILURE_SHIPPING_TEMPLATES,
        error: error
    };
};

var shouldFetchShippingTemplates = function shouldFetchShippingTemplates(state, filter) {
    var shippingTemplates = state.shippingTemplate.shippingTemplates;
    if (shippingTemplates.items.length === 0) {
        return true;
    }
    if (shippingTemplates.isFetching) {
        return false;
    }
    return true;
};

var fetchShippingTemplatesIfNeeded = exports.fetchShippingTemplatesIfNeeded = function fetchShippingTemplatesIfNeeded(filter) {
    return function (dispatch, getState) {
        if (shouldFetchShippingTemplates(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestShippingTemplates(filter));
                return (0, _api.fetchShippingTemplates)(filter).then(function (response) {

                    if (!response.ok) {
                        return Promise.reject(response);
                    }
                    return response.json();
                }).then(function (json) {
                    return dispatch(receiveShippingTemplates(filter, json));
                }).catch(function (error) {
                    return dispatch(failureShippingTemplates(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/shipping_template.js
// module id = 900
// module chunks = 0